import apiUrl from '../../../../../utils/settings';

export const digiLockerInitiateUrl = () => apiUrl + '/digilocker/v2/initiate';
export const digiLockerFetchUrl = (sessionId) =>
  apiUrl + `/digilocker/v2/fetch/${sessionId}?doc_type=AADHAAR`;

export const sendBeneficiaryOtpUrl = () =>
  apiUrl + '/v2/benefit-beneficiary/send-beneficiary-otp';
export const verifyBeneficiaryOtpUrl = () =>
  apiUrl + '/v2/benefit-beneficiary/verify-beneficiary-otp';
export const verifyUserPanUrl = () =>
  apiUrl + '/v2/benefit-beneficiary/verify-user-pan';
export const beneficiaryNomineeV2Url = () =>
  apiUrl + '/v2/benefit-beneficiary/beneficiary-nominee-v2';
export const verifyDigiLockerAccountUrl = (mobileNumber) =>
  apiUrl + `/digilocker/v2/verify-account?mobile_number=${mobileNumber}`;
